import { HttpParams } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import * as moment from 'moment';

import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from "../../../services/authentication.service";

@Component({
  selector: 'app-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss']
})
export class DownloadListComponent implements OnInit, OnDestroy {
  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  minDate: Date;
  maxDate: Date;
  loading = false;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  documentList = [];
  approvedList = [];
  isLoadingConfirm = false;
  showResults = false;
  successEmailList = [];
  failedEmailList = [];
  documentNumber = '';
  email = '';
  buyerName = '';
  sellerName = '';
  errorMessage;

  calendarLocale = CALENDAR_LOCALE.TH;

  selectedMonth;
  modal: NgbModalRef;
  isCheckAll = false;

  private subs = new SubSink();
  private tableCol: any[];

  constructor(private modalService: NgbModal,
              private authService: AuthenticationService,
              private downloadService: DownloadService,
              private translate: TranslateService) {}

  ngOnInit() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.getDocumentRequestList();
  }

  loadTexts() {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
  }

  getDocumentRequestList() {
    this.loading = true;
    const params = new HttpParams()
      .set('page_size', this.itemsPerPage.toString())
      .set('page', this.currentPage.toString())
      .set('status', 'False')
      .set('email', this.email)
      .set('buyer_name', this.buyerName)
      .set('seller_name', this.sellerName)
      .set('start_date', this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '')
      .set('end_date', this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '')
      .set('document_number', this.documentNumber);
    this.subs.add(
      this.downloadService.getDocumentRequestList(params).subscribe(
        documents => {
          this.documentList = documents['results'];
          this.totalItems = documents['count'];
          this.loading = false;
        },
        error => {
          console.log('error', error);
        }
      )
    );
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  search() {
    this.currentPage = 1;
    this.getDocumentRequestList();
  }

  clearSearch() {
    this.documentNumber = '';
    this.startDate = new Date(moment().format('YYYY') + '-01-01');
    this.endDate = new Date(moment().format('YYYY') + '-12-30');
    this.email = '';
    this.buyerName = '';
    this.sellerName = '';
    this.getDocumentRequestList();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  open(content) {
    this.showResults = false;
    this.modal = this.modalService.open(content);
  }

  toggleStatusChange() {
    this.approvedList = this.documentList.filter(obj => obj.status);
    console.log(this.approvedList)
  }

  confirm() {
    this.isLoadingConfirm = true;
    this.errorMessage = null;

    this.subs.add(
      this.downloadService.updateDocumentRequest(this.approvedList).subscribe(
        res => {
          this.successEmailList = res.success_email_list;
          this.failedEmailList = res.failed_email_list;
        },
        error => {
          console.log('error', error);
          this.checkErrorMsg(error);
          this.isLoadingConfirm = false;

        },
        () => {
          this.isLoadingConfirm = false;
          this.showResults = true;
          this.approvedList = [];
          this.getDocumentRequestList();
        }
      )
    );
  }

  checkErrorMsg(error) {
    // this.errorMsgForShow = this.apiService.getErrorMessage(error);
    const errormsg = (error.error.message[0]);
    if (this.translate.currentLang === 'en') {
      this.errorMessage = errormsg;

    } else {
      this.errorMessage = '';
    }
  }

  checkAll() {
    this.documentList.map(obj => {
      if ((this.isAccountantAdminTH() || this.isAccountantTH()) && (obj['seller_name'] === 'IQVIA (Thailand) Co., Ltd.')) {
        obj['status'] = this.isCheckAll;
      }
      else if ((this.isAccountantAdminINC() || this.isAccountantINC()) && (obj['seller_name'] === 'IQVIA INC. - Thailand')) {
         obj['status'] = this.isCheckAll;
      }
      else if (this.isAdmin()) {
        obj['status'] = this.isCheckAll;
      }
    });
    this.toggleStatusChange();
  }

  deleteDownloadRequest(id) {
    this.downloadService.deleteDocumentRequest(id).subscribe(
      () => {
        this.documentList = this.documentList.filter(obj => obj.id !== id);
      },
      error => console.log('error', error)
    );
  }

  optionChanged() {
    this.getDocumentRequestList();
  }

  pageChanged() {
    this.getDocumentRequestList();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  isAccountantTH() {
    return this.authService.isAccountantTH();
  }

  isAccountantINC() {
    return this.authService.isAccountantINC();
  }

  isAccountantAdminTH() {
    return this.authService.isAccountantAdminTH();
  }

  isAccountantAdminINC() {
    return this.authService.isAccountantAdminINC();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  thOrInc(document) {
    if ((this.isAccountantAdminTH() || this.isAccountantTH()) && (document.seller_name === 'IQVIA (Thailand) Co., Ltd.')){
      return true;
    }
    if ((this.isAccountantAdminINC() || this.isAccountantINC()) && (document.seller_name === 'IQVIA INC. - Thailand')){
      return true;
    }
    if (this.isAdmin()) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.ts